import Api from '@/services/api.js';

export default {
  addDriverProject(details) {
    return Api.post('driverProjects/', details);
  },
  getAllDriverProjects() {
    return Api.get('driverProjects/');
  },
  deleteDriverProject(driverProject) {
    return Api.delete(`driverProjects/${driverProject}`);
  },
  updateDriverProject(driverProject) {
    var driverProjectId = driverProject.id;
    return Api.put(`driverProjects/${driverProjectId}`, driverProject);
  },
  // getDriverProjectsById(id, type) {
  //     if(type == 'driver') {
  //         return this.getDriverProjectsByDriver(id)
  //     } else {
  //         return this.getDriverProjectsByProject(id)
  //     }       
  // },
  getDriverProjectsByDriver(id) {
    return Api.get('driverProjects/byDriver/' + id);
  },
  getDriverProjectsByProject(id) {
    return Api.get('driverProjects/byProject/' + id);
  },
}